// Ekran başlığındaki (i) düğmesi: tıklanınca rehber kaydındaki içerikle "Nasıl kullanılır" penceresini açar.
// Kullanım: <GuideButton guideKey="accounts.list" />  (renkli başlıkta color="inherit")
import React, { useMemo, useState } from 'react';
import { IconButton, Tooltip, type IconButtonProps } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import UsageGuideDialog from '../UsageGuideDialog';
import { GUIDES, type GuideKey } from '../../../guides/registry';

export interface GuideButtonProps extends Omit<IconButtonProps, 'onClick' | 'children'> {
  guideKey: GuideKey;
  /** Varsayılan: "Nasıl kullanılır?" */
  tooltip?: string;
  /** Dışarıdan açık tutulacaksa (ör. ⋮ menüsünden de açılıyorsa). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const GuideButton: React.FC<GuideButtonProps> = ({ guideKey, tooltip, open: openProp, onOpenChange, ...iconProps }) => {
  const entry = GUIDES[guideKey];
  const { t } = useTranslation(entry.ns);
  const { t: tg } = useTranslation('guides');
  const [openState, setOpenState] = useState(false);
  const open = openProp ?? openState;
  const setOpen = (v: boolean) => {
    if (openProp === undefined) setOpenState(v);
    onOpenChange?.(v);
  };
  const label = tooltip ?? tg('common.open', 'Nasıl kullanılır?');
  // İçerik yalnız açıkken üretilir
  const content = useMemo(() => (open ? entry.build(t) : null), [open, entry, t]);

  return (
    <>
      <Tooltip title={label}>
        <IconButton aria-label={label} {...iconProps} onClick={() => setOpen(true)}>
          <InfoOutlinedIcon fontSize={iconProps.size === 'small' ? 'small' : 'medium'} />
        </IconButton>
      </Tooltip>
      {content && <UsageGuideDialog open={open} onClose={() => setOpen(false)} {...content} />}
    </>
  );
};

export default GuideButton;
